// src/components/Feedback.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const API_BASE = process.env.REACT_APP_API_URL;

const Feedback = () => {
  const [message, setMessage] = useState('');
  const [submissionMessage, setSubmissionMessage] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user is authenticated
    const token = localStorage.getItem('token');
    if (!token) {
      // If not authenticated, redirect to login page
      navigate('/login', { state: { from: '/feedback' }, replace: true });
      return;
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmissionMessage('');

    if (!message.trim()) {
      setSubmissionMessage('Please enter your feedback message.');
      return;
    }

    try {
      const token = localStorage.getItem('token'); // Get token for the request
      await axios.post(`${API_BASE}/api/feedback`, { message }, {
        headers: { Authorization: `Bearer ${token}` }, // Attach token to header
        withCredentials: true,
      });
      setSubmissionMessage('✅ Thank you for your feedback! It has been submitted.');
      setMessage(''); // Clear form
    } catch (err) {
      console.error('Feedback submission failed:', err.response?.data || err.message);
      if (err.response?.status === 401 || err.response?.status === 403) {
        setSubmissionMessage('❌ Submission failed. Please log in to submit feedback.');
      } else {
        setSubmissionMessage('❌ Feedback submission failed. Please try again.');
      }
    }
  };

  // If not authenticated, the useEffect will handle the redirect, so we don't render the form
  if (!localStorage.getItem('token')) {
    return null;
  }

  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-br from-cyan-600 to-blue-800 font-inter text-white">
      <div className="bg-white p-8 rounded-xl shadow-2xl w-full max-w-md bg-opacity-10 backdrop-filter backdrop-blur-lg border border-white/20">
        <h2 className="text-3xl font-bold mb-6 text-center text-white">Provide Feedback</h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-white text-sm font-bold mb-2" htmlFor="message">
              Your Feedback
            </label>
            <textarea
              id="message"
              placeholder="Tell us what you think..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              className="shadow appearance-none border rounded w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:shadow-outline bg-white/20 border-white/30 placeholder-gray-300"
              rows="5"
              required
            ></textarea>
          </div>
          <button
            type="submit"
            className="bg-white text-cyan-700 font-bold py-2 px-4 rounded-full w-full hover:bg-gray-200 transition duration-300"
          >
            Submit Feedback
          </button>
        </form>
        {submissionMessage && (
          <p className={`mt-4 text-center ${submissionMessage.startsWith('✅') ? 'text-green-300' : 'text-red-300'}`}>
            {submissionMessage}
          </p>
        )}
      </div>
    </div>
  );
};

export default Feedback;